import { languagesByCountry } from '@/modules/config/locale.js'

// `makeCanonicalUrl` generates a url for canonical link.
// Search params are intentionally removed to consolidate duplicate URLs.
// If you make any change, please also update the corresponding Ruby
// implementation in `app/services/canonical_url_generator.rb`.
function makeCanonicalUrl (url, route) {
  if (!url) return ''

  url = new URL(url)
  url.search = ''

  const language = route.query.language
  if (language === undefined) return url.toString()

  const languageQuery = makeLanguageQuery(language)
  if (languageQuery) url.searchParams.append('language', languageQuery)
  return url.toString()
}

function makeLanguageQuery (language) {
  const languageKey = getLanguageKey(language)

  if (
    !isLanguageQueryApplicableForCountry() ||
    !doLanguageBelongToCountry(languageKey) ||
    isLanguageDefaultForCountry(languageKey)
  ) return null

  return language
}

const LANGUAGE_QUERY_APPLICABLE_LOCALES = ['hk', 'id', 'jp', 'th', 'tw', 'vn']

function getLanguageKey (language) {
  if (['tw', 'vn'].includes(I18n.siteCountryLs) && ['zh-TW', 'vi-VN'].includes(language)) {
    return language
  }

  return `lng_${language.toLowerCase()}`
}

function isLanguageQueryApplicableForCountry () {
  return (LANGUAGE_QUERY_APPLICABLE_LOCALES.includes(I18n.siteCountryLs))
}

function isLanguageDefaultForCountry (languageKey) {
  return (languagesByCountry[I18n.siteCountryLs].defaultLanguage === languageKey)
}

function doLanguageBelongToCountry (languageKey) {
  return (languagesByCountry[I18n.siteCountryLs].languages.includes(languageKey))
}

export default makeCanonicalUrl
